import { render, staticRenderFns } from "./GroupsSites.vue?vue&type=template&id=06c56ac2&"
import script from "./GroupsSites.vue?vue&type=script&lang=js&"
export * from "./GroupsSites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports